import React from 'react';
import { motion } from 'framer-motion';
import { bonos } from '../data/content';
export function Bonos() {
  return <section aria-labelledby="bonos-titulo" className="w-full bg-cream py-14 sm:py-20" data-id="element-20" data-mp="2hdmmpkxwsw3y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-21" data-mp="2lddb5hzyr05b">
        <h2 id="bonos-titulo" className="text-center font-display text-3xl font-extrabold text-navy text-balance sm:text-4xl" data-id="element-22" data-mp="2q4v9rzeikon4">
          🎁 6 Bonos estratégicos — siempre incluidos
        </h2>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-23" data-mp="302jftlhklikl">
          {bonos.map((bono, index) => <motion.li key={bono.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05,
          ease: 'easeOut'
        }} className="flex gap-4 rounded-2xl border border-navy/10 bg-white p-5 shadow-card" data-id="element-24" data-mp="351m9yaw0i4ds" data-mpi={index}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-celeste-light font-display text-sm font-extrabold text-navy" aria-hidden="true" data-id="element-25" data-mp="3e49cbzvl2a42">
                {bono.number}
              </span>
              <div className="flex-1" data-id="element-26" data-mp="2zf4w2o8cmfyl">
                <h3 className="font-display text-base font-extrabold leading-tight text-navy sm:text-lg" data-id="element-27" data-mp="2zg68aw13p8hw">
                  🎁 Bono {Number(bono.number)} — {bono.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/75" data-id="element-28" data-mp="3s3ip0pkkym3a">
                  {bono.description}
                </p>
                <p className="mt-3 flex items-center gap-2" data-id="element-29" data-mp="3n2urdl1uj703">
                  <span className="text-sm font-bold text-navy/40 line-through" data-id="element-30" data-mp="3i6e22niwumlf">
                    {bono.price}
                  </span>
                  <span className="rounded-full bg-green-600 px-2.5 py-0.5 font-display text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-31" data-mp="2bqu09zhif6h6">
                    Gratis
                  </span>
                </p>
              </div>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl rounded-2xl bg-navy px-6 py-4 text-center font-display text-lg font-extrabold text-white sm:text-xl" data-id="element-32" data-mp="12s27yrb9h0e8">
          Valor total bonos: <span className="line-through opacity-60" data-id="element-33" data-mp="tre2wm3uiadh">$53.000</span>{' '}
          → <span className="text-gold" data-id="element-34" data-mp="f316jo0uipig">GRATIS</span> con tu MegaPack
        </p>
      </div>
    </section>;
}